import { render } from "./PropertyEdit.vue?vue&type=template&id=639a1004&scoped=true"
import script from "./PropertyEdit.vue?vue&type=script&lang=js"
export * from "./PropertyEdit.vue?vue&type=script&lang=js"

import "./PropertyEdit.vue?vue&type=style&index=0&id=639a1004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639a1004"]])

export default __exports__